import { NumberInput, Switch, Textarea, TextInput } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons";
import ActionCellRender from "../../components/actionCellRender";
import {
  ExpenseRoleListField,
  ExpenseThresholdModeField,
} from "../../components/expense/expenseClaimFields";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
  PageList,
} from "../../components/pageList";

const apiEntity = "expenseType";

const formSchema = {
  title: "Expense Type",
  display: {
    mode: ENUM_FORM_DISPLAY.DRAWER,
    size: "lg",
  },
  apiEntity,
  initialValues: {
    code: "",
    name: "",
    section: "",
    thresholdMode: "NONE",
    thresholdAmount: null,
    approverRoles: [],
    aboveApproverRoles: [],
    checklist: "",
    blockMessage: "",
    active: true,
  },
  validate: {
    code: (value) => (!value ? "Enter a code" : null),
    name: (value) => (!value ? "Enter a name" : null),
  },
  layout: {
    containers: [
      {
        key: "main",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
        props: {},
      },
    ],
    fields: [
      {
        name: "code",
        component: TextInput,
        parent: "main",
        props: { label: "Code", required: true, description: "Stable code, such as PROJECT" },
      },
      {
        name: "name",
        component: TextInput,
        parent: "main",
        props: {
          label: "Name",
          required: true,
          description: "This name is sent to AI OCR as an allowed expense type",
        },
      },
      {
        name: "section",
        component: TextInput,
        parent: "main",
        props: { label: "Policy section" },
      },
      {
        name: "thresholdMode",
        component: ExpenseThresholdModeField,
        parent: "main",
        props: {},
      },
      {
        name: "thresholdAmount",
        component: NumberInput,
        parent: "main",
        props: { label: "Threshold amount (HKD)", precision: 2, hideControls: true },
      },
      {
        name: "approverRoles",
        component: ExpenseRoleListField,
        parent: "main",
        props: {
          label: "Approver roles",
          description: "Role names in order, separated by commas. Example: CFO, CEO",
        },
      },
      {
        name: "aboveApproverRoles",
        component: ExpenseRoleListField,
        parent: "main",
        props: {
          label: "Approver roles above the threshold",
          description: "Used when the threshold is an amount or an amount per attendee",
        },
      },
      {
        name: "checklist",
        component: Textarea,
        parent: "main",
        props: { label: "First-step checklist", minRows: 2 },
      },
      {
        name: "blockMessage",
        component: Textarea,
        parent: "main",
        props: {
          label: "Message when the amount is above the blocked threshold",
          minRows: 2,
        },
      },
      {
        name: "active",
        component: Switch,
        parent: "main",
        props: { label: "Active" },
      },
    ],
  },
};

const tableSchema = {
  showActionColumn: true,
  searchableFields: ["code", "name", "section"],
  columns: [
    { field: "code", headerName: "Code", filter: true },
    { field: "name", headerName: "Name", filter: true },
    { field: "section", headerName: "Section" },
    { field: "thresholdMode", headerName: "Threshold" },
    {
      field: "active",
      headerName: "Active",
      cellRender: (col, data) => (data.active === false ? "No" : "Yes"),
    },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [{ name: "edit", icon: IconPencil, props: {} }],
      actionMenu: [
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: { color: "red" },
        },
      ],
    },
  ],
};

const ExpenseTypePage = () => (
  <PageList
    title="Expense Types"
    apiEntity={apiEntity}
    tableSchema={tableSchema}
    formSchema={formSchema}
  />
);

export default ExpenseTypePage;
